import React from 'react';

const KoboLogo = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 134 25"
        height="15px"
        fit
        preserveAspectRatio="xMidYMid meet"
    >
        <path
            d="M-1.80529e-06 0H3.01694V10.6043L7.09869 5.74645H10.7072L5.97473 11.2559L11.1213 18.4834H7.57193L3.07609 12.0853H3.01694V18.4834H-1.80529e-06V0Z"
            transform="translate(86.7815)"
            fill="#bf0000"
        ></path>
        <path
            d="M5.61979 11.2559C7.7494 11.2559 8.10433 9.06398 8.10433 6.69431C8.10433 4.32464 7.80856 2.1327 5.61979 2.1327C3.49019 2.1327 3.13526 4.32464 3.13526 6.69431C3.19441 9.06398 3.49019 11.2559 5.61979 11.2559ZM0 6.69431C0 2.48815 1.95214 -1.12995e-07 5.61979 -1.12995e-07C9.28745 -1.12995e-07 11.2396 2.48815 11.2396 6.69431C11.2396 10.9005 9.28745 13.3886 5.61979 13.3886C1.95214 13.3294 0 10.8412 0 6.69431Z"
            transform="translate(97.6069 5.4502)"
            fill="#bf0000"
        ></path>
        <path
            d="M5.32402 16.7062C7.217 16.7062 7.57194 14.218 7.57194 12.1445C7.57194 9.83412 7.33531 7.34597 5.32402 7.34597C3.54935 7.34597 2.95779 9.95261 2.95779 12.1445C2.95779 15.3436 3.43103 16.7062 5.32402 16.7062ZM2.95779 7.28673C3.43103 6.63507 4.37752 5.45024 6.32966 5.45024C9.40576 5.45024 10.7072 8.05687 10.7072 12.1445C10.7072 15.6991 9.46492 18.8389 5.32402 18.8389C1.95214 18.8389 1.80529e-06 16.9431 1.80529e-06 13.0924V0H2.95779V7.28673Z"
            transform="translate(110.503)"
            fill="#bf0000"
        ></path>
        <path
            d="M5.67895 11.2559C7.80856 11.2559 8.16349 9.06398 8.16349 6.69431C8.16349 4.32464 7.86771 2.1327 5.67895 2.1327C3.54934 2.1327 3.19441 4.32464 3.19441 6.69431C3.19441 9.06398 3.49019 11.2559 5.67895 11.2559ZM-3.61058e-06 6.69431C-3.61058e-06 2.48815 1.95214 -1.12995e-07 5.61979 -1.12995e-07C9.28745 -1.12995e-07 11.2396 2.48815 11.2396 6.69431C11.2396 10.9005 9.28745 13.3886 5.61979 13.3886C1.95214 13.3294 -3.61058e-06 10.8412 -3.61058e-06 6.69431Z"
            transform="translate(122.689 5.4502)"
            fill="#bf0000"
        ></path>
        <path
            d="M49.5133 0H2.25661e-07L3.96343 3.96919L49.5133 0Z"
            transform="translate(16.327 21.0308)"
            fill="#bf0000"
        ></path>
        <path
            d="M8.99167 0.35545V0.947868C8.04518 0.35545 7.27615 0 6.09304 0C2.60285 0 4.51322e-07 3.13981 4.51322e-07 7.04976C4.51322e-07 10.9597 2.66201 14.0995 6.09304 14.0995C7.217 14.0995 8.04518 13.7441 8.99167 13.1517V13.7441H12.0086V0.35545H8.99167ZM6.09304 10.8412C4.37752 10.8412 3.13525 9.18246 3.13525 7.04976C3.13525 4.91706 4.37752 3.25829 6.09304 3.25829C7.80856 3.25829 8.99167 4.91706 8.99167 7.04976C9.05083 9.18246 7.80856 10.8412 6.09304 10.8412Z"
            transform="translate(11.9495 4.73938)"
            fill="#bf0000"
        ></path>
        <path
            d="M7.98602 2.25989e-07V7.87915C7.98602 9.36019 6.98038 10.6043 5.50148 10.6043C4.02259 10.6043 3.01694 9.36019 3.01694 7.87915V2.25989e-07H-9.02645e-07V7.87915C-9.02645e-07 11.1374 2.18876 13.7441 5.44233 13.7441C6.92122 13.7441 8.04518 12.9147 8.04518 12.9147V13.3886H11.1213V2.25989e-07H7.98602Z"
            transform="translate(37.3273 5.09485)"
            fill="#bf0000"
        ></path>
        <path
            d="M3.0761 13.7441V5.86493C3.0761 4.38389 4.08175 3.13981 5.56064 3.13981C7.03953 3.13981 8.04518 4.38389 8.04518 5.86493V13.7441H11.0621V5.86493C11.0621 2.60663 8.87336 0 5.61979 0C4.1409 0 3.01694 0.829384 3.01694 0.829384V0.35545H9.02645e-07V13.8033H3.0761V13.7441Z"
            transform="translate(70.6319 4.73938)"
            fill="#bf0000"
        ></path>
        <path
            d="M3.19441 16.8246V11.6114H5.44233L9.34661 16.8246H13.31L8.57758 10.545C10.0565 9.47867 11.003 7.76066 11.003 5.80569C11.003 2.60664 8.40011 -2.82486e-08 5.2057 -2.82486e-08H0V16.7654H3.19441V16.8246ZM3.19441 3.25829H5.26486C6.6846 3.25829 7.86771 4.44313 7.86771 5.86493C7.86771 7.28673 6.6846 8.47156 5.26486 8.47156H3.19441V3.25829Z"
            transform="translate(0 1.65881)"
            fill="#bf0000"
        ></path>
        <path
            d="M7.09869 13.6256C6.80291 13.8033 6.50713 13.981 6.09304 13.981C5.61979 13.981 4.6733 13.6256 4.6733 12.3223V6.57583H7.27615V3.37678H4.6733V5.64973e-08H1.59721V3.37678H-1.80529e-06V6.57583H1.59721V12.3815C1.59721 15.4028 3.84512 17.1801 6.15219 17.1801C6.98037 17.1801 8.16349 16.8839 9.10998 16.3507L7.09869 13.6256Z"
            transform="translate(49.5133 1.71802)"
            fill="#bf0000"
        ></path>
        <path
            d="M5.79726 10.782L11.0621 4.50237H6.80291L3.13525 9.18246V0H0V17.891H3.13525V12.3815L7.63109 17.891H11.8903L5.79726 10.782Z"
            transform="translate(25.7327 0.592407)"
            fill="#bf0000"
        ></path>
        <path
            d="M6.03388 0C2.48454 0 9.02645e-07 3.08057 9.02645e-07 7.04976C9.02645e-07 11.1967 3.19441 14.0995 6.32966 14.0995C7.92687 14.0995 9.99732 13.5664 11.7128 11.0782L9.05083 9.53792C6.98037 12.6185 3.49019 11.0782 3.0761 7.99763H11.8311C12.6002 3.13981 9.46492 0 6.03388 0ZM8.69589 5.33175H3.19441C3.84512 2.19194 8.10433 2.01422 8.69589 5.33175Z"
            transform="translate(57.6177 4.73938)"
            fill="#bf0000"
        ></path>
    </svg>
);

export default KoboLogo;
